module.exports = __webpack_public_path__ + "img/form-bg--991.4d63940.jpg";